import { PropsWithChildren, useCallback } from "react";
import { Pressable, StyleProp, ViewStyle } from "react-native";

import { createStyles } from "../theme";

export type ListItemProps<T extends string | number = number> =
  PropsWithChildren<{
    disabled?: boolean;
    id: T;
    onPress?: (id: T) => void;
    style?: StyleProp<ViewStyle>;
  }>;

export function ListItem<T extends string | number = number>({
  children,
  disabled = false,
  id,
  onPress,
  style,
}: ListItemProps<T>) {
  // Handlers
  const handlePress = useCallback(() => {
    onPress?.(id);
  }, [id, onPress]);

  // Render
  const isDisabled = disabled || !onPress;

  return (
    <Pressable
      disabled={isDisabled}
      onPress={handlePress}
      style={({ pressed }) => [
        $.container,
        style,
        pressed && !isDisabled && $.active,
      ]}
    >
      {children}
    </Pressable>
  );
}

const $ = createStyles({
  container: {
    p: "4",
  },
  active: {
    backgroundColor: "surfaceActive",
  },
});
